import template from './setup.html';
import controller from './setup.controller';
import './setup.scss';

let setupComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default setupComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/setup.component.js